module.exports = __webpack_public_path__ + "img/point-w.9ceebd20.svg";